export default __webpack_public_path__ + "static/media/menorah2.498905ea.jpg";